import React, { Component, Fragment }  from 'react';
import './CadeReport.css';

const CadeReportPerson = (props) => {
    
    return (

        <Fragment>
                <h3>{props.personFirstName}  {props.personLastName}</h3>
                <h3>{props.personBirthDate}</h3>
                <h4>Assessment: {props.assessmentDate}</h4>
        </Fragment>

    );
}

export default CadeReportPerson;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeReportPerson.js